import { MessagePathRecord, TopicRecord } from "@/shared/domain/topics";

import { FilterMatch } from "../Sidebar/filterResult";

export interface FilterResult {
  type: "topic" | "messagePath";
  match?: FilterMatch;
}

export interface MessagePathFilterResult extends FilterResult {
  type: "messagePath";
  messagePath: MessagePathRecord;
}

export interface TopicFilterResult extends FilterResult {
  type: "topic";
  topic: TopicRecord;
}

export function isMessagePathFilterResult(
  result: FilterResult,
): result is MessagePathFilterResult {
  return result.type === "messagePath";
}

export function isTopicFilterResult(
  result: FilterResult,
): result is TopicFilterResult {
  return result.type === "topic";
}
